import React from "react";
import { Tag, Typography } from "antd";
import { fallbackSubjectView } from "../utils/workbenchNewSubjectView";

const { Text } = Typography;

type Props = {
    completedTasks: number;
    completionPercent: number;
    totalTasks: number;
};

const WorkbenchNewSubjectTopPanel: React.FC<Props> = ({
    completedTasks,
    completionPercent,
    totalTasks,
}) => (
    <div className="workbench-new-subject-top-panel">
        <div className="workbench-new-subject-stage-panel">
            <div className="workbench-new-subject-stage-copy">
                <Text type="secondary">Current stage</Text>
                <div className="workbench-new-subject-stage-title">
                    <span className="workbench-new-subject-stage-dot" />
                    {fallbackSubjectView.stage}
                </div>
                <p>We are exchanging terms and waiting for missing items.</p>
            </div>
            <div className="workbench-new-subject-stage-track">
                {[
                    "Intake",
                    "In Discussion",
                    "Agreed",
                    "Active",
                    "Renewal",
                    "Closed",
                ].map((stage) => (
                    <div
                        className={
                            stage === fallbackSubjectView.stage
                                ? "workbench-new-subject-stage-step active"
                                : "workbench-new-subject-stage-step"
                        }
                        key={stage}
                    >
                        <span className="workbench-new-subject-stage-node" />
                        {stage}
                    </div>
                ))}
            </div>
        </div>
        <div className="workbench-new-subject-readiness">
            <div className="workbench-new-subject-readiness-heading">
                <strong>Decision readiness</strong>
                <Tag className="workbench-new-subject-readiness-pill">
                    Not ready
                </Tag>
            </div>
            <div className="workbench-new-subject-readiness-subtitle">
                Missing items
            </div>
            <ul>
                <li>Signed slip</li>
                <li>Layer 2 premium confirmation</li>
                <li>Final brokerage confirmation</li>
            </ul>
            <div className="workbench-new-subject-progress-label">
                {completedTasks} of {totalTasks} items complete
            </div>
            <div
                aria-label={`${completedTasks} of ${totalTasks} items complete`}
                className="workbench-new-subject-progress"
                role="progressbar"
                aria-valuemax={100}
                aria-valuemin={0}
                aria-valuenow={completionPercent}
            >
                <span style={{ width: `${completionPercent}%` }} />
            </div>
        </div>
    </div>
);

export default WorkbenchNewSubjectTopPanel;
